import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import {
  Heading3,
  RoundedButton,
} from "../../../common/components/styled/styled";
import { DataGrid } from "../helpers/DataGrid";
import { ValidFromDateModal } from "../helpers/ValidFromDateModal";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";

type Props = {
  columns: any[];
  rows: any[];
  onSave: (rows: any[]) => void;
  onUndo: () => void;
  selectedDate: string;
  setupNew: (date: Date) => void;
  cancelNew: () => void;
  salesAccountConfigDates: string[];
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  setSelectedDate: (date: string) => void;
};

export const EditSalesAccountsConfig = ({
  columns,
  rows,
  onSave,
  onUndo,
  setupNew,
  cancelNew,
  selectedDate,
  salesAccountConfigDates,
  isModalOpen,
  setIsModalOpen,
  setSelectedDate,
}: Props) => {
  const { t } = useTranslation("settings");

  return (
    <>
      <Heading3>{t("salesAccounts")}</Heading3>
      <Box mt={2} display="flex" flexDirection="column" width="200px">
        <RoundedButton
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ marginBottom: 3 }}
          onClick={() => setIsModalOpen(true)}
        >
          {t("common:add")}
        </RoundedButton>
        <FormControl>
          <InputLabel>{t("effectiveFrom")}</InputLabel>
          <Select
            value={selectedDate || ""}
            label={t("effectiveFrom")}
            onChange={(event: SelectChangeEvent) =>
              setSelectedDate(event.target.value)
            }
          >
            {salesAccountConfigDates.map((date) => (
              <MenuItem key={date} value={date}>
                {date}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <DataGrid
        columns={columns}
        rows={rows}
        onSave={onSave}
        onUndo={onUndo}
        hideSave={false}
        actions={["delete"]}
      />
      <ValidFromDateModal
        isOpen={isModalOpen}
        onAccept={setupNew}
        onCancel={cancelNew}
        selectedDate={null}
        label={t("common:add")}
      />
    </>
  );
};
